import { Controller } from "@hotwired/stimulus"

export default class FocusNewItemController extends Controller {
  static targets = ["list"]
  static values = { enabled: { type: Boolean, default: false } }

  connect() {
    this.enabled = this.enabledValue
  }

  enable() {
    this.enabled = true
  }

  focus() {
    if (!this.enabled) return

    const lastItem = this.listTarget.lastElementChild
    if (!lastItem) return

    const inlineEditEl = lastItem.querySelector(
      '[data-controller~="inline-edit"]'
    )

    if (inlineEditEl) {
      this.application
        .getControllerForElementAndIdentifier(inlineEditEl, "inline-edit")
        ?.openEditMode()
    } else {
      lastItem.querySelector("input[type=text]")?.focus()
    }

    this.enabled = this.enabledValue
  }
}
